import React from "react";
import classes from "./LoadingIcon.module.css";
function LoadingIcon() {
  return (
    <div
      className={`${classes["loading-icons-container"]} transition ease-in-out duration-300`}
    >
      <div className={classes["lds-ellipsis"]}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default LoadingIcon;
